<template>
	<router-link :to="mroute" style="text-decoration:none;"  class="ai-tab-bar-button">
		<!-- <div :style="`width: ${appBarTabWidth}px; height: ${appBarHeight}px;`"/> -->
		<div :style="`width: ${appBarTabWidth}px; height: ${appBarHeight}px; background: ${background}; text-align: center; font-size: 12px; cursor: pointer;`">

			<v-icon style="font-size: 22px; padding-bottom: 3px; padding-top: 13px;" color="" class="">{{micon}}</v-icon><br/>
			<div style="color: #ddddee;"><slot></slot></div>
			<div v-if="selected" :style="`width: ${appBarTabWidth-1}px; height: 4px; position: absolute; bottom: 0px; background-color: #2196f3`"/>

		</div>
	</router-link>
</template>



<script>

// ----------------------------------------------------
//  Main script
// ----------------------------------------------------

import agile from '@/shift/agile';

  export default
  {
	name: 'AppBarTabButton',
	
	props: function()
	{
		let newProps = {};
		newProps.micon = { type: String };
		newProps.mroute = { type: String };

		return newProps;
	}(),

	data: () =>
    ({
		selected: true,
		background: 'transparent',
	}),

    computed:
	{
		appBarHeight()
		{
			return agile.appBarHeight();
		},

		appBarTabWidth()
		{
			return agile.appBarTabWidth();
		},
	},
	
	watch:
	{
		$route()
		{
			this.updateButtonState();

			//background: radial-gradient(#1788b0, #10617d);
			
		}
	},


	mounted()
	{
		this.updateButtonState();
	},

    methods:
    {
		updateButtonState()
		{
			if (this.$router.currentRoute.path.includes(this.mroute))
			{
				this.selected = true;
				this.background = 'radial-gradient(#3b577d, #2d425f)';
			}
			else
			{
				this.background = 'transparent';
				this.selected = false;
			}
		}
    }

  }

</script>

<style>
/* .v-btn:before
{
	background-color: white;
} */
</style>